import { Type } from 'class-transformer';
import { GLAccountSelectorResultDto } from '../../common/gl-account/glaccount-selector-result-dto';
import { DimensionSelectorResultDto } from '../../common/dimensions/dimension-selector-result-dto';
import { APServiceChargeRawDto } from './ap-service-charge-raw-dto';
import { GLAccountLabelSelectorResultDto } from '../../common/gl-account/gl-account-label-selector-result-dto';

export class APServiceChargeEditorResultDto {
    @Type(() => APServiceChargeRawDto)
    serviceCharge: APServiceChargeRawDto;
    allowAddPayCharge: boolean;
    allowAddPayBill: boolean;
    entityUsesSubCategory: boolean;
    @Type(() => DimensionSelectorResultDto)
    glDimensions: DimensionSelectorResultDto[];
    @Type(() => GLAccountSelectorResultDto)
    glAccounts: GLAccountSelectorResultDto[];
    @Type(() => GLAccountLabelSelectorResultDto)
    glAccountLabels: GLAccountLabelSelectorResultDto[];
}
